import SimpleParallax from "simple-parallax-js/vanilla";

var image = document.querySelectorAll('.work__img-wrapper, .full-image, .next-project__media, .next-project__parallax img, .work-hero__inner div, .sticky-images__images a, .contact__img-inner, .about__img-inner, .full-slider__parallax');
new SimpleParallax(image, {  delay: 1, scale: 1.1,   transition: 'cubic-bezier(0,0,0,1)' });

const lenis = new Lenis({
    duration: 2,
    smoothWheel: true,
    wheelMultiplier: 0.8,
    touchMultiplier: 1.5,
    lerp: 0.05, 
});

function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);



AOS.init({
    anchorPlacement: 'bottom-bottom',
    once: true
});

// function decodeHTML(html) {
//     const txt = document.createElement("textarea");
//     txt.innerHTML = html;
//     return txt.value;
// }

// const textAnim = $(".split-anim-title");


// if (textAnim) {
//     textAnim.each(function () {
//         const _this = $(this);
//         let html = _this.html().replace(/<br\s*\/?>/gi, ' <br> ');
//         html = decodeHTML(html);
//         const cleanHtml = html.trim().replace(/\s+/g, ' ');
//         const textArr = cleanHtml.split(" ");

//         _this.text("");

//         let line = 1;
//         let lastOffsetTop = null;

//         textArr.forEach(function (word, index) {
//             if (word === "<br>") {
//                 const span = document.createElement("span");
//                 span.classList.add('brl')
//                 _this.append(span);
//                 return;
//             }

//             if (word === "|") {
//                 const span = document.createElement("span");
//                 span.classList.add('brl')
//                 _this.append(span);
//                 return;
//             }

//             if (word === "||") {
//                 const span = document.createElement("span");
//                 span.classList.add('brl-space')
//                 _this.append(span);
//                 return;
//             }

//             const span = document.createElement("span");
//             const span_inner = document.createElement("span");

//             $(span).addClass("split-anim");
//             $(span_inner).addClass("split-anim__inner");
//             span_inner.textContent = word;
//             span.append(span_inner);
//             _this.append(span);

//             const empt = document.createElement("span");
//             $(empt).text(" ");
//             _this.append(empt); 

//             const currentOffsetTop = span.offsetTop;

//             if (lastOffsetTop === null) {
//                 lastOffsetTop = currentOffsetTop;
//             } else if (currentOffsetTop > lastOffsetTop) {
//                 lastOffsetTop = currentOffsetTop;
//             }
//             $(span_inner).addClass(`count-${line}`);
//             line++;

//         });
//     });
// }


// VanillaTilt.init(document.querySelectorAll(".work__img-anim "), {
//     reverse: true,
//     max: 5,
//     // perspective: 1000,   
//     scale: 1,
//     speed: 2000,
//     easing: "cubic-bezier(.03,.98,.52,.99)",
// });


// anim to pages

document.addEventListener('click', e => {
    const link = e.target.closest('a');

    if (!link) return;

    const href = link.getAttribute('href');

    if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('tel:') ||
        href.startsWith('mailto:') ||
        link.target === '_blank' ||
        link.hasAttribute('download') ||
        link.hasAttribute('data-fslightbox') ||
        e.ctrlKey ||
        e.metaKey ||
        e.shiftKey
    ) {
        return;
    }

    e.preventDefault();

    document.body.classList.add('preload-start');

    setTimeout(() => {
        window.location.href = href;
       
    }, 850);

});
document.body.classList.remove('preload-end');


window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        document.body.classList.remove('preload-start');
    }
});



setTimeout(() => {

    const classes = '.work__title, .work__subtitle, .contact__title, .contact__left, .contact__right, .about__title, .work__filters-title .split-anim-title, .work__filters-item, .project-details__title'

const titles = document.querySelectorAll(classes)
titles.length && titles.forEach(title => {
    if(title) {
        title.classList.add('aos-animate')
    }
})
}, 200)
